import React from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { IoArrowBack } from "react-icons/io5";
import WalmartProductPage from "../components/Walmart/WalmartProductPage";

const WalmartProductDetail = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const productId = searchParams.get("product_id");

  const handleBack = () => {
    navigate("/product");
  };

  if (!productId) {
    return (
      <div className="bg-primary-bg min-h-screen">
        <div className="title border-b-2 border-b-border w-full md:p-4 p-3 text-gray-100 flex items-center gap-4">
          <button
            onClick={handleBack}
            className="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-secondary-bg transition-colors duration-200 cursor-pointer bg-secondary-bg"
            aria-label="Back to Product Search"
          >
            <IoArrowBack className="md:text-2xl text-xl text-gray-100 text-primary" />
          </button>
          <p className="text-white font-bold">Walmart Product Detail</p>
        </div>
        <div className="p-5">
          <div className="text-primary-light text-sm">
            Missing Walmart product ID. Please go back and select a product
            again.
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-primary-bg min-h-screen">
      <div className="title border-b-2 border-b-border w-full md:p-4 p-3 text-gray-100 flex items-center gap-4">
        <button
          onClick={handleBack}
          className="flex items-center justify-center w-10 h-10 rounded-lg hover:bg-secondary-bg transition-colors duration-200 cursor-pointer bg-secondary-bg"
          aria-label="Back to Product Search"
        >
          <IoArrowBack className="md:text-2xl text-xl text-gray-100 text-primary" />
        </button>
        <p className="text-white font-bold">Walmart Product Detail</p>
      </div>
      <div className="p-2 md:p-5">
        <WalmartProductPage productId={productId} />
      </div>
    </div>
  );
};

export default WalmartProductDetail;

